module.exports = __webpack_public_path__ + "static/img/5.3f4ce4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/5.png
// module id = yhQq
// module chunks = 1